module.exports = __webpack_public_path__ + "static/media/money.9d858f03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/money.svg
// module id = 2140
// module chunks = 0